'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// ISSUE use `babel-plugin-module-resolver`?
// ISSUE move to coat-utils? makeFormatterBySpec


var _propTypes = require('prop-types');

var _DocsTable = require('./DocsTable');

var _DocsTable2 = _interopRequireDefault(_DocsTable);

var _pipe = require('lodash/fp/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _withPropsOnChange = require('recompose/withPropsOnChange');

var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);

var _withStateByProps = require('coact-utils/withStateByProps');

var _withStateByProps2 = _interopRequireDefault(_withStateByProps);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _makeFormatter = require('../../../utils/makeFormatter');

var _makeFormatter2 = _interopRequireDefault(_makeFormatter);

var _mapPropsToFormatterSpec = require('../../../utils/makeFormatter/mapPropsToFormatterSpec');

var _mapPropsToFormatterSpec2 = _interopRequireDefault(_mapPropsToFormatterSpec);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var flattenSchemaCol = function flattenSchemaCol(schema, col) {
  return Array.isArray(col.key) ? _extends({}, _ramda2.default.path(_ramda2.default.intersperse('contents', col.key), schema.contents), col) : _extends({}, schema.contents[col.key], col);
};
var DocsTable = (0, _composeWithScope2.default)((0, _injectProps2.default)({
  schema: _propTypes.object.isRequired,
  docs: _propTypes.array.isRequired,
  columns: _propTypes.array,
  page: _propTypes.object
}), (0, _withStateByProps2.default)('noWrapObj', 'setNoWrapObj', function (nextProps, props) {
  if (!props) return {};
  if (nextProps.docs !== props.docs) return {};
  return undefined;
}), (0, _withHandlers2.default)({
  toggleWrap: function toggleWrap(_ref) {
    var setNoWrapObj = _ref.setNoWrapObj;
    return function (id) {
      return setNoWrapObj(function (obj) {
        return _extends({}, obj, _defineProperty({}, id, !obj[id]));
      });
    };
  }
}), (0, _withState2.default)('lastPos', 'setLastPos', {}), (0, _withHandlers2.default)({
  onMouseDown: function onMouseDown(_ref2) {
    var setLastPos = _ref2.setLastPos;
    return function (e) {
      return setLastPos({ x: e.screenX, y: e.screenY });
    };
  },
  onMouseUp: function onMouseUp(_ref3) {
    var lastPos = _ref3.lastPos,
        setLastPos = _ref3.setLastPos,
        gotoUpdateDoc = _ref3.page.gotoUpdateDoc,
        isDoubleClick = _ref3.isDoubleClick;
    return function (e) {
      return function (docId) {
        if (e.screenX - lastPos.x < 3 && e.screenY - lastPos.y < 3 && !isDoubleClick) {
          return gotoUpdateDoc(docId);
        }
        return setLastPos({});
      };
    };
  }
}),

// add formatter in columns
(0, _withPropsOnChange2.default)(['schema', 'columns'], function (_ref4) {
  var schema = _ref4.schema,
      columns = _ref4.columns;
  return {
    columns: columns.map((0, _pipe2.default)(
    // flatten field schema and column setting as formatter spec
    // col => ({ ...schema.contents[col.key], ...col }),
    function (col) {
      return flattenSchemaCol(schema, col);
    }, function (col) {
      return col.formatter ?
      // 有 formatter 直接用
      col : _extends({}, col, {
        formatter: (0, _pipe2.default)(_mapPropsToFormatterSpec2.default, _makeFormatter2.default)(col)
      });
    }))
  };
}), (0, _exposeProps2.default)(['noWrapObj', 'toggleWrap', 'columns', 'onMouseDown', 'onMouseUp']))(_DocsTable2.default);

DocsTable.displayName = 'DocsTable';

exports.default = DocsTable;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/DocsTable/index.js
// module id = 1701
// module chunks = 0